<template>
  <div class="order-person-limit">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        订单员权限
      </div>
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
          <el-form-item label="员工姓名:" prop="userName">
            <el-select v-model="searchForm.userName" clearable placeholder="请选择">
              <el-option
                v-for="item in orderPersonList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区:" prop="areaName">
            <el-select
              v-model="searchForm.areaName"
              filterable
              remote
              placeholder="请输入所在地区"
              :remote-method="getAreaOptions"
              :loading="loading"
            >
              <el-option
                v-for="item in areaOptions"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaName"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所在部门:" prop="deptName">
            <el-select
              v-model="searchForm.deptName"
              filterable
              remote
              placeholder="请输入所在部门"
              :remote-method="getDepartOptions"
              :loading="loading"
            >
              <el-option
                v-for="item in departOptions"
                :key="item.deptCode"
                :label="item.deptName"
                :value="item.deptName"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="tableLoading" @click="doSearch">
              搜索
            </el-button>
            <el-button type="default" @click="resetForm('searchForm')">
              重置
            </el-button>
          </el-form-item>
        </el-form>
        <div class="operate-btn-wrap">
          <el-button type="primary" @click="addNewOrderPerson">
            新增订单员<i class="el-icon-plus" />
          </el-button>
          <el-button type="default" @click="deleteAllOrderPerson">
            批量删除
          </el-button>
          <el-button type="default" @click="copyOrderPerson">
            复制权限
          </el-button>
        </div>
        <div v-loading="tableLoading" class="tableBody">
          <el-table ref="multipleTable" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed="left" />
            <el-table-column type="index" width="60" label="序号" align="left">
              <template slot-scope="scope">
                <span>{{ (page.currentPage - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="员工姓名" align="left" />
            <el-table-column prop="deptName" label="部门" align="left" />
            <el-table-column prop="areaName" label="地区" align="left" />
            <el-table-column prop="privilegeType" label="审批类型" align="left" />
            <el-table-column label="操作" align="left" width="120" fixed="right">
              <template v-slot="{row}">
                <el-button type="text" @click="editOrderPerson(row)">
                  编辑
                </el-button>
                <el-button type="text" @click="deleteOrderPerson(row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right;margin-top: 10px">
            <el-pagination
              :page-sizes="[10, 20, 30, 40]"
              :page-size.sync="page.pageSize"
              :current-page.sync="page.currentPage"
              layout="total, prev, pager, next, jumper,sizes"
              :total="page.total"
              hide-on-single-page
              @size-change="handerSizeChange"
              @current-change="handerCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加新的订单员" :visible.sync="addOrderPersonVisible" width="800px">
      <add-new-order-person v-if="addOrderPersonVisible" ref="newOrderPerson" :order-person-list="orderPersonList" :type-options-list="typeList" :depart-options="departOptions" :area-options="areaOptions" :loading="loading" @isShow="isShow" @DepartOptions="DepartOptions" @AreaOptions="AreaOptions" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOrderPersonVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改订单员资料" :visible.sync="editOrderPersonVisible" width="800px">
      <edit-order-person v-if="editOrderPersonVisible" ref="editOrderPerson" :edit-form="editForm" :order-person-list="orderPersonList" :type-options-list="typeList" :depart-options="departOptions" :area-options="areaOptions" :loading="loading" @isShowEdit="isShowEdit" @DepartOptions="DepartOptions" @AreaOptions="AreaOptions" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="editOrderPersonVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="复制订单员权限" :visible.sync="copyOrderPersonVisible" width="600px">
      <copy-order-person v-if="copyOrderPersonVisible" ref="copyOrderPerson" :order-person-list="orderPersonList" @isShowCopy="isShowCopy" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyOrderPersonVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumCopyOrderPerson">确定复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectInfoList, getDeptNameList, getSaleAreaList, deleteInfo, getDictData, getOrderClerkByUserCodeAndTypeList } from '@/API/index.js';
import addNewOrderPerson from './addNewOrderPerson';
import editOrderPerson from './editOrderPerson';
import copyOrderPerson from './copyOrderPerson';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'OrderPersonLimit',
  data () {
    return {
      searchForm: {
        userName: '',
        deptName: '',
        areaName: ''
      },
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      tableData: [],
      addOrderPersonVisible: false,
      editOrderPersonVisible: false,
      departOptions: [], // 部门
      areaOptions: [], // 地区
      typeList: [], // 类别
      loading: false,
      editForm: {},
      multipleSelection: [],
      copyOrderPersonVisible: false

    };
  },
  components: {
    addNewOrderPerson,
    editOrderPerson,
    copyOrderPerson
  },
  computed: {
    ...mapState({
      orderPersonList: state => state.enumeration.orderPersonList
    })
  },
  methods: {
    ...mapActions('enumeration', [
      'initOrderPersonlist'
    ]),
    addNewOrderPerson () {
      this.addOrderPersonVisible = true;
    },
    initData () {
      this.tableLoading = true;
      let params = {
        userName: this.searchForm.userName,
        deptName: this.searchForm.deptName,
        areaName: this.searchForm.areaName,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      getSelectInfoList(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableLoading = false;
          this.tableData = res.data.data.list;
          this.page.total = res.data.data.total;
        }
      }).catch((res) => {
        this.tableLoading = false;
        this.$notify.warning('加载失败');
      });
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.page.currentPage = 1;
      this.initData();
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    editOrderPerson (row) {
      this.editOrderPersonVisible = true;
      getOrderClerkByUserCodeAndTypeList(row.userId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.loading = false;
          if (json.data.length > 0) {
            this.editForm.addPersonList = json.data;
            this.editForm.userId = row.userId;
            this.editForm.userName = row.userName;
          }
        }
      }).catch((res) => {
        this.loading = false;
      });
    },
    deleteOrderPerson (row) {
      let rowList = [];
      rowList.push(row.id);
      this.$confirm('是否删除此条订单员权限?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteInfo(rowList).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('删除成功');
            this.initData();
          }
        }).catch((res) => {
          this.$message.warning('删除失败');
        });
      }).catch(() => {
        this.$notify({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitUpdate () {
      this.$refs.editOrderPerson.submitEditOrderPerson();
    },
    getDepartOptions (query) {
      this.loading = true;
      if (query !== '') {
        getDeptNameList(query).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.loading = false;
            this.departOptions = json.data;
          }
        }).catch((res) => {
          this.loading = false;
        });
      }
    },
    getAreaOptions (query) {
      this.loading = true;
      if (query !== '') {
        getSaleAreaList(query).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.loading = false;
            this.areaOptions = json.data;
          }
        }).catch((res) => {
          this.loading = false;
        });
      }
    },
    getTypeOptions () {
      let params = ['ORDER_CLERK_PRIVILEGE_TYPE'];
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.typeList = data[0].dictDataVOS;
          console.log(this.typeList);
        }
      });
    },
    DepartOptions (query) {
      this.getDepartOptions(query);
    },
    AreaOptions (query) {
      this.getAreaOptions(query);
    },
    submitAdd () {
      this.$refs.newOrderPerson.submitNewOrderPerson();
    },
    isShow (val) {
      this.addOrderPersonVisible = val;
      this.initData();
    },
    isShowEdit (val) {
      this.editOrderPersonVisible = false;
      this.initData();
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteAllOrderPerson () {
      let rowList = [];
      if (!this.multipleSelection.length) {
        this.$message.warning('至少选择一条记录');
        return;
      }
      this.multipleSelection.forEach((item) => {
        rowList.push(item.id);
      });
      this.$confirm('是否删除这些订单员权限?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteInfo(rowList).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('删除成功');
            this.initData();
          }
        }).catch((res) => {
          this.$message.warning('删除失败');
        });
      }).catch(() => {
        this.$notify({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    copyOrderPerson () {
      this.copyOrderPersonVisible = true;
    },
    sumCopyOrderPerson () {
      this.$refs.copyOrderPerson.copyOrderPerson();
    },
    isShowCopy (val) {
      this.copyOrderPersonVisible = false;
      this.initData();
    }
  },
  mounted () {
    this.initData();
    this.initOrderPersonlist();
    this.getTypeOptions();
  }
};
</script>

<style scoped>

</style>
